import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activitySettingsRoutes: MenuInterface[] = [
    {
        code: 'ActivityParameters',
        route: [
            {
                content: '$type/settings',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'PermanencesSettings',
        route: [
            {
                content: '$type/settings/permanences',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'GroupedActions',
        route: [
            {
                content: '$type/settings/grouped-actions/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'ActivityParametersCancellationFees',
        route: [
            {
                content: '$type/settings/cancellation-fees/list',
                focus: 'empty',
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ]
    },
    {
        code: 'ChoiceSession',
        route: [
            {
                content: '$type/settings/choice-session/list',
                focus: 'empty'
            }, {
                primaryRoute:'content',
                queryParams: {closeButton: 1}
            }
        ]
    }
];
